import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignCreationMethodStep =
  () => import(/* webpackChunkName: "campaign-creation-method-step.async" */ './campaign-creation-method-step')
    .then(({ CampaignCreationMethodStepWithI18n }) => CampaignCreationMethodStepWithI18n);

const DelayedCampaignCreationMethodLazyRepository =
  () => import(/* webpackChunkName: "campaign-creation-method-step.async" */ './campaign-creation-method-lazy-repository')
    .then(({ CampaignCreationMethodLazyRepositoryWithI18n }) => CampaignCreationMethodLazyRepositoryWithI18n);

export const CampaignCreationMethodStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD,
  view: DelayedCampaignCreationMethodStep,
  repository: DelayedCampaignCreationMethodLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
